import { isNullish, PAGINATION_HITS_PER_PAGE } from '@caresend/utils';
import '../../../database/algoliaConfig/indices.js';
import { needsNewKey } from '../../../database/algoliaConfig/methods.js';
import '@caresend/types';
import 'firebase/auth';
import { getAlgoliaOrdersAPIKeyRequest } from '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';

const procedureRelationshipKeys = {
    rescheduledID: true,
    dropOffPlaceGroups: true,
    supplyTransferID: true,
};
const draftWaypointRelationshipKeys = {
    waypointID: {
        waypointActions: true,
    },
    procedures: true,
};
const supplyTransferRelationshipKeys = {
    shipmentIDs: true,
};
const generateSupplyTransferRelationshipKeyObjectToNestLayer = (nestingCount, base) => {
    if (nestingCount === 0)
        return supplyTransferRelationshipKeys;
    return {
        ...base,
    };
};
const generateProcedureRelationshipKeyObjectToNestLayer = (nestingCount, base = procedureRelationshipKeys) => {
    if (nestingCount === 0)
        return procedureRelationshipKeys;
    return {
        ...base,
        rescheduledID: generateProcedureRelationshipKeyObjectToNestLayer(nestingCount - 1, procedureRelationshipKeys),
        supplyTransferID: generateSupplyTransferRelationshipKeyObjectToNestLayer(nestingCount, supplyTransferRelationshipKeys),
    };
};
/**
 * Check if the algolia key needs to be updated and update it if it does.
 */
const getUpdatedAlgoliaOrdersAPIKey = async (algoliaKey, isPatientRequest, officeID) => {
    let key = algoliaKey;
    if (!key || needsNewKey(key)) {
        key = await getAlgoliaOrdersAPIKeyRequest({
            isPatientRequest,
            officeID: isPatientRequest ? undefined : officeID,
        });
    }
    return key;
};
const denormalizedOrderHasSortingDate = (order) => !isNullish(order.sortingDate);
const getPageParams = (page, filters) => {
    const hitsPerPage = PAGINATION_HITS_PER_PAGE;
    return {
        page,
        hitsPerPage,
        filters,
    };
};

export { denormalizedOrderHasSortingDate, draftWaypointRelationshipKeys, generateProcedureRelationshipKeyObjectToNestLayer, generateSupplyTransferRelationshipKeyObjectToNestLayer, getPageParams, getUpdatedAlgoliaOrdersAPIKey, procedureRelationshipKeys, supplyTransferRelationshipKeys };
